import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashAlt, faUsersViewfinder, faGlobe, faChartPie, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { faPenToSquare, faPlusSquare } from "@fortawesome/free-regular-svg-icons";
import { api, getToken } from "../../../services/apis/auth-api/apiUrl";
import * as end_point from "../../../config/config";
import { domainsProps, clientsProps, findSegmentProps } from "../../../utils/types";
import React, { ChangeEvent, useEffect, useState } from "react";
import Modal from "../modal/modal";
import UpdateClient from "../modal/jdl-modals/requirements/updateClient";
import DeleteModalContent from "../modal/jdl-modals/requirements/deleteModalContent";
import AddSegment from "../modal/jdl-modals/requirements/addSegment";
import SubSegments from "../modal/jdl-modals/requirements/SubSegments";
import AddSubSegment from "../modal/jdl-modals/requirements/addSubSegment";
import AddModalContent from "../modal/jdl-modals/requirements/addModalContent";
import UpdateModal from "../modal/jdl-modals/requirements/updateModalContent";

export default function Dropdowns () {

    const [domains, setDomains] = useState<domainsProps[]>([]);
    const [clients, setClients] = useState<clientsProps[]>([]);
    const [segments, setSegments] = useState<findSegmentProps[]>([]);
    const [domainId, setDomainId] = useState<number>();
    const [search, setSearch] = useState('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalChildren, setModalChildren] = useState<React.JSX.Element | null>(null);
    const [clientLoading, setClientLoading] = useState<boolean>(true);
    const [DomainLoading, setDomainLoading] = useState<boolean>(true);
    const [segmentLoading, setSegmentLoading] = useState<boolean>(true);

    function createModalContent(content : React.JSX.Element){
        setModalChildren(content);
        setShowModal(true);
    }
    
    function handleSearch (e : ChangeEvent<HTMLInputElement>){
        setSearch(e.target.value);
    }

    const clientsData = clients.filter((data)=>
        data.client_name.toLowerCase().includes(search.toLowerCase())
    )
    
    useEffect(()=>{
        async function setDomainTableValues(){
            try{
                const domains = await api.get(end_point.GET_ALL_DOMAINS_END_POINT, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setDomains(domains.data);
                setDomainId(domains.data[0].id);
                setDomainLoading(false);
            }catch(e){}
        }
        setDomainTableValues();
    },[showModal]);

    useEffect(()=>{
        async function getSegments() {
            try{
                const segments = await api.get(end_point.GET_SEGMENT_BY_DOMAIN_END_POINT+domainId, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setSegments(segments.data);
                setSegmentLoading(false);
            }catch(e){}
        }
        getSegments();
    },[domainId, showModal]);

    useEffect(()=>{
        async function setClientsTableValues () {
            try{
                const clients = await api.get(end_point.GET_CLIENTS_END_POINT, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setClients(clients.data);
                setClientLoading(false);
            }catch(e){}
        }
       setClientsTableValues ();
    },[showModal])

    return (
        <div>
            <div className="w-full bg-white px-2 py-4">
                <h1 className="text-md">
                   Role Requirements
                </h1>
            </div>
            <div className='flex'>
                <div className="max-h-tbl w-full max-w-full overflow-y-auto overflow-x-auto hide-scrollbar border bg-white">
                    <div className="mx-2 my-2 text-gray-600 uppercase">
                        <FontAwesomeIcon icon={faUsersViewfinder} />&nbsp;
                        Clients
                    </div>
                    <div className='w-full flex items-center bg-white px-2 py-4'>
                        <div>
                            <button type="button" onClick={() => createModalContent(<AddModalContent name={"Client"} />)} className="button button-vcc-primary text-sm">
                                <FontAwesomeIcon icon={faPlus} />&nbsp;
                                Add
                            </button>
                        </div>
                        <div className="ms-auto">
                            <input type="text" className="text-box" value={search} onChange={handleSearch} placeholder="Search client" />
                        </div>
                    </div>
                    <table className="w-full border">
                        <thead className="table-fixed-header border">
                            <tr>
                                <th className='table-headers'>#</th>
                                <th className='table-headers'>Client Name</th>
                                <th className='table-headers'>Date Added</th>
                                <th className='table-headers'>Action</th>
                            </tr>
                        </thead>
                        <tbody className="text-center">
                            {clientLoading ? (
                                <>
                                    <tr className="hover:bg-gray-300">
                                        <td className='table-body px-2'>
                                            <div className="table-loading"></div>
                                        </td>
                                        <td className='table-body px-2'>
                                            <div className="table-loading"></div>
                                        </td>
                                        <td className='table-body px-2'>
                                            <div className="table-loading"></div>
                                        </td>
                                        <td className='table-body px-2'>
                                            <div className="table-loading"></div>
                                        </td>
                                    </tr>
                                    <tr className="hover:bg-gray-300">
                                        <td className='table-body px-2'>
                                            <div className="table-loading"></div>
                                        </td>
                                        <td className='table-body px-2'>
                                            <div className="table-loading"></div>
                                        </td>
                                        <td className='table-body px-2'>
                                            <div className="table-loading"></div>
                                        </td>
                                        <td className='table-body px-2'>
                                            <div className="table-loading"></div>
                                        </td>
                                    </tr>
                                </>
                            ) : (
                                <>
                                    {clientsData.length > 0 ? (
                                        <>
                                            {clientsData.map((value, index)=>(
                                                <tr className="hover:bg-gray-300">
                                                    <td className='table-body px-2'>{index + 1}</td>
                                                    <td className='table-body px-2'>{value.client_name}</td>
                                                    <td className='table-body px-2'>{value.date_created}</td>
                                                    <td className='table-body px-2'>
                                                        <div className='flex gap-4 justify-center items-center'>
                                                            <i onClick={()=>createModalContent(<UpdateClient id={value.id} client_name={value.client_name} date_created="" />)} className="cursor-pointer text-blue-500">
                                                                <FontAwesomeIcon icon={faPenToSquare} />
                                                            </i>
                                                            <i onClick={()=>createModalContent(<DeleteModalContent id={value.id} name={value.client_name} endPoint={end_point.DELETE_CLIENT_END_POINT} />)} className="cursor-pointer text-red-500">
                                                                <FontAwesomeIcon icon={faTrashAlt} />
                                                            </i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    ) : (
                                        <>
                                            <tr className="hover:bg-gray-300">
                                                <td className='table-body px-2' colSpan={4}>
                                                    No client Found.
                                                </td>
                                            </tr>
                                        </>
                                    )}
                                </>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="bg-white w-full p-2 border flex flex-col gap-4">
                    
                    <div>
                        <div className="mx-2 my-2 flex text-gray-600 uppercase">
                            <div>
                                <FontAwesomeIcon icon={faGlobe} />&nbsp;
                                Domains
                            </div>
                            <div className="ms-auto">
                                <button type="button" onClick={()=>{createModalContent(<AddModalContent name={"Domain"} />)}} className="button button-vcc-primary text-sm">
                                    <FontAwesomeIcon icon={faPlus} />&nbsp;
                                    New Domain
                                </button>
                            </div>
                        </div>
                        <div className="max-h-44 max-w-full overflow-y-auto overflow-x-auto hide-scrollbar">
                            <table className="w-full border">
                                <thead className="table-fixed-header border">
                                    <tr>
                                        <th className='table-headers'>#</th>
                                        <th className='table-headers'>Domain Name</th>
                                        <th className='table-headers'>Action</th>
                                    </tr>
                                </thead>
                                <tbody className="text-center">
                                    {DomainLoading ? (
                                        <>
                                            <tr className="hover:bg-gray-300">
                                                <td className='table-body px-2'>
                                                    <div className="table-loading"></div>
                                                </td>
                                                <td className='table-body px-2'>
                                                    <div className="table-loading"></div>
                                                </td>
                                                <td className='table-body px-2'>
                                                    <div className="table-loading"></div>
                                                </td>
                                            </tr>
                                            <tr className="hover:bg-gray-300">
                                                <td className='table-body px-2'>
                                                    <div className="table-loading"></div>
                                                </td>
                                                <td className='table-body px-2'>
                                                    <div className="table-loading"></div>
                                                </td>
                                                <td className='table-body px-2'>
                                                    <div className="table-loading"></div>
                                                </td>
                                            </tr>
                                        </>
                                    ) : (
                                        <>
                                            {domains.map((values, index)=>(
                                                <tr className="hover:bg-gray-300">
                                                    <td className='table-body px-2'>{index + 1}</td>
                                                    <td className='table-body px-2'>{values.domain_name}</td>
                                                    <td className='table-body px-2'>
                                                        <div className='flex gap-4 justify-center items-center'>
                                                            <i onClick={()=>createModalContent(<UpdateModal id={values.id} name={values.domain_name} endPoint={end_point.UPDATE_DOMAIN_END_POINT} />)} className="cursor-pointer text-blue-500">
                                                                <FontAwesomeIcon icon={faPenToSquare} />
                                                            </i>
                                                            <i onClick={()=>createModalContent(<AddSegment id={values.id} domain_name={values.domain_name} />)} className="cursor-pointer text-gray-600">
                                                                <FontAwesomeIcon icon={faPlusSquare} />
                                                            </i>
                                                            <i onClick={()=>createModalContent(<DeleteModalContent id={values.id} name={values.domain_name} endPoint={end_point.DELETE_DOMAIN_END_POINT} />)} className="cursor-pointer text-red-500">
                                                                <FontAwesomeIcon icon={faTrashAlt} />
                                                            </i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div>
                        <div className="mx-2 my-2 flex text-gray-600 uppercase">
                            <div>
                                <FontAwesomeIcon icon={faChartPie} />&nbsp;
                                Segments
                            </div>
                            <div className="ms-auto">
                                <select className="text-box max-w-56 h-9" onChange={(e) =>setDomainId(parseInt(e.target.value))}>
                                    {domains.map((value)=>(
                                        <option value={value.id}>{value.domain_name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="max-h-64 max-w-full overflow-y-auto overflow-x-auto hide-scrollbar">
                            <table className="w-full border">
                                    <thead className="table-fixed-header border">
                                        <tr>
                                            <th className='table-headers'>#</th>
                                            <th className='table-headers'>Segment Name</th>
                                            <th className='table-headers'>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-center">
                                        {segmentLoading ? (
                                            <>
                                               <tr className="hover:bg-gray-300">
                                                    <td className='table-body px-2'>
                                                        <div className="table-loading"></div>
                                                    </td>
                                                    <td className='table-body px-2'>
                                                        <div className="table-loading"></div>
                                                    </td>
                                                    <td className='table-body px-2'>
                                                        <div className="table-loading"></div>
                                                    </td>
                                                </tr>  
                                                <tr className="hover:bg-gray-300">
                                                    <td className='table-body px-2'>
                                                        <div className="table-loading"></div>
                                                    </td>
                                                    <td className='table-body px-2'>
                                                        <div className="table-loading"></div>
                                                    </td>
                                                    <td className='table-body px-2'>
                                                        <div className="table-loading"></div>
                                                    </td>
                                                </tr>  
                                            </>
                                        ) : (
                                            <>
                                                {segments.length > 0 ? (
                                                    <>
                                                        {segments.map((values, index)=>(
                                                            <tr className="hover:bg-gray-300">
                                                                <td className='table-body px-2'>{index + 1}</td>
                                                                <td className='table-body px-2'>{values.segment_name}</td>
                                                                <td className='table-body px-2'>
                                                                    <div className='flex gap-4 justify-center items-center'>
                                                                        <i onClick={()=>createModalContent(<UpdateModal id={values.id} name={values.segment_name} endPoint={end_point.UPDATE_SEGMENT_NAME_END_POINT} />)} className="cursor-pointer text-blue-500">
                                                                            <FontAwesomeIcon icon={faPenToSquare} />
                                                                        </i>
                                                                        <i onClick={()=>createModalContent(<SubSegments id={values.id} segment_name={values.segment_name} />)} className="cursor-pointer text-gray-600">
                                                                            <FontAwesomeIcon icon={faMagnifyingGlass} />
                                                                        </i>
                                                                        <i onClick={()=>createModalContent(<AddSubSegment id={values.id} segment_name={values.segment_name} />)} className="cursor-pointer text-gray-600">
                                                                            <FontAwesomeIcon icon={faPlusSquare} />
                                                                        </i>
                                                                        <i onClick={()=>createModalContent(<DeleteModalContent id={values.id} name={values.segment_name} endPoint={end_point.DELETE_SEGMENT_END_POINT} />)} className="cursor-pointer text-red-500">
                                                                            <FontAwesomeIcon icon={faTrashAlt} />
                                                                        </i>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <>
                                                        <tr className="hover:bg-gray-300">
                                                            <td colSpan={3} className='table-body px-2'>
                                                                No segment available.
                                                            </td>
                                                        </tr>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
            {showModal &&(
                <Modal onClose={()=>setShowModal(false)}> 
                    {modalChildren}
                </Modal>
            )}
        </div>
    );
}